import React from 'react'
import { styled } from 'styled-components'

import { ReactComponent as Home } from '@/assets/svgs/home.svg'
import { ReactComponent as Hotel } from '@/assets/svgs/hotel.svg'
import { theme } from '@/theme'
import { IconGenerator } from '@/UIkit/IconGenerator'

const circleSize = 76
const halfCircleSize = circleSize / 2
const padding = circleSize / 5
const iconSize = 16

const CornerImage = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-end;

  position: absolute;

  top: -${halfCircleSize}px;
  left: -${halfCircleSize}px;
  width: ${circleSize}px;
  height: ${circleSize}px;
  padding: ${padding}px;

  color: ${theme.colors.white};
  border-radius: 50%;
  background-color: ${theme.colors.sapphireDark};

  z-index: 1;
`

export const CornerPropertyType = ({ isHotel }: { isHotel: boolean }) => (
  <CornerImage>
    <IconGenerator
      iconComponent={isHotel ? Hotel : Home}
      width={iconSize}
      height={iconSize}
    />
  </CornerImage>
)
